import { Spinner } from "reactstrap"

function MultipleSpinners({ size }) {
  return <div className="multiple-spinners">
    <Spinner color="light" type="grow" size={size}>Loading...</Spinner>
    <Spinner color="secondary" type="grow" size={size}>Loading...</Spinner>
    <Spinner color="dark" type="grow" size={size}> Loading...</Spinner>
    <Spinner color="success" type="grow" size={size}>Loading...</Spinner>
    <Spinner color="danger" type="grow" size={size}>Loading...</Spinner>
    <Spinner color="warning" type="grow" size={size}>Loading...</Spinner>
    <Spinner color="info" type="grow" size={size}>Loading...</Spinner>
    <Spinner color="primary" type="grow" size={size}>Loading...</Spinner>
  </div>
}

export default MultipleSpinners
